import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  createVehicleImage,
  deleteVehicleImage,
  updateVehicleImageProcessSort,
} from "../../services/VehicleService";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useTranslation } from "react-i18next";
import "react-image-crop/dist/ReactCrop.css";
import axios from "axios";
import { getSettingsCompanyDetails } from "../../services/settingsServices";
import * as fabric from "fabric";
import { Stage, Layer, Image as KonvaImage, Line, Circle } from "react-konva";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { PhotoSlider } from "react-photo-view";

const VehicleImage = ({ setActiveTab, vehicleProcessList, activeTab }) => {
  const [modifyImportModal, setModifyImportModal] = useState(false);
  const [files, setFiles] = useState([]);
  const fabricCanvasRef = useRef(null);
  const { t } = useTranslation();
  const photoRefs = useRef([]);

  const vehicleId = localStorage.getItem("vehicleId");
  const [selectedImage, setSelectedImage] = useState(null);

  const [rotation, setRotation] = useState(0);
  const canvasRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [crop, setCrop] = useState({ unit: "%", width: 50, height: 50 });
  const [resizeWidth, setResizeWidth] = useState(300);
  const [resizeHeight, setResizeHeight] = useState(300);
  const [highlights, setHighlights] = useState([]);
  const [selectedColor, setSelectedColor] = useState("#ff0000");
  const [isCropping, setIsCropping] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [isLoadingColor, setIsLoadingColor] = useState(false);
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [isDrawing, setIsDrawing] = useState(false);
  const [btnLoader, setbtnLoading] = useState(false);

  const [loadingImageId, setLoadingImageId] = useState(null);

  const [tool, setTool] = useState("circle");
  const [toolImage, setToolImage] = useState(false);
  const [shapes, setShapes] = useState([]);
  const [newShape, setNewShape] = useState(null);
  const [color, setColor] = useState("#ff0000");
  const stageRef = useRef(null);
  const [cropRect, setCropRect] = useState(null); // { x, y, width, height }
  const cropStart = useRef(null);

  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);

  const handleMouseDown = (e) => {
    const { x, y } = e.target.getStage().getPointerPosition();

    if (tool === "line") {
      const newLine = { type: "line", points: [x, y, x, y], id: Date.now() };
      setShapes([...shapes, newLine]);
      setNewShape(newLine);
      setIsDrawing(true);
    } else if (tool === "circle") {
      const newCircle = { type: "circle", x, y, radius: 0, id: Date.now() };
      setNewShape(newCircle);
      setIsDrawing(true);
    }
  };

  const handleMouseMove = (e) => {
    if (!isDrawing || !newShape) return;

    const { x, y } = e.target.getStage().getPointerPosition();

    if (newShape.type === "line") {
      const updatedLine = {
        ...newShape,
        points: [newShape.points[0], newShape.points[1], x, y],
      };
      setShapes((prev) => [...prev.slice(0, -1), updatedLine]);
      setNewShape(updatedLine);
    } else if (newShape.type === "circle") {
      const dx = x - newShape.x;
      const dy = y - newShape.y;
      const radius = Math.sqrt(dx * dx + dy * dy);

      const updatedCircle = { ...newShape, radius };
      setNewShape(updatedCircle);

      // Don't push circle until mouse up
    }
  };

  const handleMouseUp = () => {
    if (newShape && newShape.type === "circle") {
      setShapes([...shapes, newShape]);
    }
    setIsDrawing(false);
    setNewShape(null);
  };

  const handleDragMove = (index, newAttrs) => {
    const updated = [...shapes];
    updated[index] = { ...updated[index], ...newAttrs };
    setShapes(updated);
  };

  const handleDelete = (id) => {
    setShapes(shapes.filter((shape) => shape.id !== id));
  };

  const handleCrop = () => {
    setIsCropping(!isCropping);
    setCropRect(null); // reset on toggle
  };

  const handleMouseCropDown = (e) => {
    if (!isCropping) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const startX = e.clientX - rect.left;
    const startY = e.clientY - rect.top;

    cropStart.current = { x: startX, y: startY };
    setCropRect({ x: startX, y: startY, width: 0, height: 0 });
  };

  const handleMouseCropeMove = (e) => {
    if (!isCropping || !cropStart.current) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const currentX = e.clientX - rect.left;
    const currentY = e.clientY - rect.top;

    const x = Math.min(cropStart.current.x, currentX);
    const y = Math.min(cropStart.current.y, currentY);
    const width = Math.abs(currentX - cropStart.current.x);
    const height = Math.abs(currentY - cropStart.current.y);

    setCropRect({ x, y, width, height });
  };

  const handleMouseCropeUp = () => {
    cropStart.current = null;
  };

  const handleCropConfirm = () => {
    if (!completedCrop || !imgRef.current) return;

    const image = imgRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const canvas = document.createElement("canvas");
    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    // Get base64 cropped image
    const croppedBase64 = canvas.toDataURL("image/jpeg");

    // If you want to update selectedImage to the cropped one:
    setSelectedImage({ url: croppedBase64 });

    // Optionally exit cropping mode
    setIsCropping(false);
  };

  const getCroppedImage = () => {
    if (!cropRect || !imgRef.current) return;

    const img = imgRef.current;
    const scaleX = img.naturalWidth / img.clientWidth;
    const scaleY = img.naturalHeight / img.clientHeight;

    const canvas = document.createElement("canvas");
    canvas.width = cropRect.width * scaleX;
    canvas.height = cropRect.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      img,
      cropRect.x * scaleX,
      cropRect.y * scaleY,
      cropRect.width * scaleX,
      cropRect.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    const croppedDataUrl = canvas.toDataURL("image/jpeg");
    return croppedDataUrl;
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    if (!canvasRef.current) return;

    const fabricCanvas = new fabric.Canvas(canvasRef.current);
    fabricCanvasRef.current = fabricCanvas;

    if (isDrawing) {
      fabricCanvas.isDrawingMode = true;
      fabricCanvas.freeDrawingBrush = new fabric.PencilBrush(fabricCanvas);
      fabricCanvas.freeDrawingBrush.width = 5;
      fabricCanvas.freeDrawingBrush.color = "red";
    } else {
      fabricCanvas.isDrawingMode = false;
    }

    if (selectedImage?.url) {
      fabric.Image.fromURL(selectedImage.url, (img) => {
        img.set({
          scaleX: 1,
          scaleY: 1,
          selectable: false,
          evented: false,
        });

        fabricCanvas.setBackgroundImage(
          img,
          fabricCanvas.renderAll.bind(fabricCanvas)
        );
      });
    }

    return () => {
      fabricCanvas.dispose();
    };
  }, [selectedImage, isDrawing]);

  const handleSaveOrder = () => {
    const validFiles = files.filter((file) => {
      return !String(file.id).startsWith("temp-");
    });

    const simplifiedFiles = validFiles.map((file, index) => ({
      id: file.id,
      sort_order: index + 1,
    }));

    const data = {
      sort_list: simplifiedFiles,
    };

    updateVehicleImageProcessSort(data)
      .then((response) => {
        toast.success(response.data.message);
        // setActiveTab("vehicle_extra_info");
        setModifyImportModal(false);
      })
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  };

  const onImageClick = (e) => {
    const { offsetX, offsetY } = e.nativeEvent;
    const newHighlight = {
      x: offsetX,
      y: offsetY,
      radius: 20,
      color: selectedColor,
    };

    setHighlights([...highlights, newHighlight]);
  };

  const onImageLoad = (img) => {
    imgRef.current = img;
  };

  useEffect(() => {
    if (
      Array.isArray(vehicleProcessList?.vehicle_image) &&
      activeTab === "vehicle_images"
    ) {
      const initialFiles = vehicleProcessList.vehicle_image.map(
        (document, index) => ({
          url: document.vehicle_image,
          id: document.id,
          sequence: document.sort_order,
        })
      );

      setFiles(initialFiles);
    }
  }, [vehicleProcessList, activeTab]);

  const handleImportModal = () => setModifyImportModal(true);
  const handleImportCloseModal = () => setModifyImportModal(false);

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files).map((file, index) => ({
      url: URL.createObjectURL(file),
      file,
      id: `temp-${Date.now()}-${index}`,
      sequence: files.length + index + 1,
    }));

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setModifyImportModal(false);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedFiles = Array.from(files);
    const [movedFile] = reorderedFiles.splice(result.source.index, 1);
    reorderedFiles.splice(result.destination.index, 0, movedFile);

    const updatedFiles = reorderedFiles.map((file, index) => ({
      ...file,
      sequence: index + 1,
    }));

    setFiles(updatedFiles);
  };

  const handleRemoveFile = (fileToRemove) => {
    const removedIndex = files.findIndex(
      (f) => f.id === fileToRemove.id || f.url === fileToRemove.url
    );

    const newList = files.filter((file) => file !== fileToRemove);
    setFiles(newList);

    if (viewerOpen) {
      if (removedIndex === viewerIndex) {
        setViewerOpen(false);
      } else if (removedIndex < viewerIndex) {
        setViewerIndex(viewerIndex - 1);
      }
    }

    setCrop(null);
    setRotation(0);
    setResizeWidth("");
    setResizeHeight("");
    setHighlights([]);

    if (fileToRemove?.id && !String(fileToRemove.id).startsWith("temp-")) {
      const data = { id: fileToRemove.id };

      deleteVehicleImage(data)
        .then((response) => {
          toast.success(response.data.message);
          setActiveTab("vehicle_images");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleImageSelect = (file) => {
    if (file.file) {
      setFiles((prevFiles) =>
        prevFiles.map((f) => (f.id === file.id ? { ...f } : f))
      );
      setSelectedImage(file);
      setCrop(null);
      setRotation(0);
      setHighlights([]);
      setIsModalOpen(true);
    } else {
      axios({
        url: file.url,
        method: "GET",
        responseType: "blob",
        headers: {
          "Cache-Control": "no-cache", // Force a fresh request
        },
      })
        .then((res) => {
          const myFile = new File([res.data], "image.png", {
            type: res.data.type,
          });

          let fileData = file;
          fileData.url = URL.createObjectURL(myFile);
          fileData.file = myFile;

          setFiles((prevFiles) =>
            prevFiles.map((f) => (f.id === fileData.id ? { ...f } : f))
          );
          setSelectedImage(fileData);
          setCrop(null);
          setRotation(0);
          setHighlights([]);
          setIsModalOpen(true);
        })
        .catch((err) => {
          console.error("Error fetching the file:", err);
        });
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // const getCroppedImage = async () => {
  //   if (!imgRef.current || !selectedImage) return;

  //   const image = imgRef.current;
  //   const canvas = document.createElement("canvas");
  //   const ctx = canvas.getContext("2d");

  //   const scaleX = image.naturalWidth / image.width;
  //   const scaleY = image.naturalHeight / image.height;

  //   let cropX = 0,
  //     cropY = 0,
  //     cropWidth = image.naturalWidth,
  //     cropHeight = image.naturalHeight;

  //   if (completedCrop) {
  //     cropX = completedCrop.x * scaleX;
  //     cropY = completedCrop.y * scaleY;
  //     cropWidth = completedCrop.width * scaleX;
  //     cropHeight = completedCrop.height * scaleY;
  //   }

  //   const radians = (rotation * Math.PI) / 180;

  //   canvas.width = cropWidth;
  //   canvas.height = cropHeight;

  //   ctx.clearRect(0, 0, canvas.width, canvas.height);
  //   ctx.save();

  //   ctx.translate(canvas.width / 2, canvas.height / 2);
  //   ctx.rotate(radians);
  //   ctx.translate(-canvas.width / 2, -canvas.height / 2);

  //   ctx.drawImage(
  //     image,
  //     cropX,
  //     cropY,
  //     cropWidth,
  //     cropHeight,
  //     0,
  //     0,
  //     cropWidth,
  //     cropHeight
  //   );

  //   ctx.restore();

  //   if (canvasRef.current) {
  //     try {
  //       const drawingDataURL = await canvasRef.current.exportImage("png");

  //       if (drawingDataURL) {
  //         const drawingImage = new Image();
  //         drawingImage.src = drawingDataURL;
  //         await new Promise((resolve) => (drawingImage.onload = resolve));

  //         // Draw the sketch overlay on top of the cropped image
  //         ctx.drawImage(drawingImage, 0, 0, cropWidth, cropHeight);
  //       }
  //     } catch (error) {
  //       console.error("Error exporting drawing:", error);
  //     }
  //   }

  //   let editedImage = canvas.toDataURL("image/jpeg");

  //   setFiles((prevFiles) =>
  //     prevFiles.map((file) =>
  //       file.id === selectedImage.id ? { ...file, url: editedImage } : file
  //     )
  //   );

  //   setSelectedImage(null);
  //   setIsModalOpen(false);
  //   setCompletedCrop(null);
  //   setHighlights([]);
  // };

  const handleAddBgColorForm = async (fileId, overrideFile = null) => {
    const selectedImage = files.find((file) => file.id === fileId);
    if (!selectedImage) return;

    let fileData = selectedImage;

    if (selectedImage?.url) {
      try {
        const res = await axios({
          url: selectedImage.url,
          method: "GET",
          responseType: "blob",
        });

        const myFile = new File([res.data], "image.png", {
          type: res.data.type,
        });

        fileData = {
          ...selectedImage,
          url: URL.createObjectURL(myFile),
          file: myFile,
        };
      } catch (err) {
        console.error("Error fetching the file:", err);
        toast.error("Failed to load selected image.");
        return;
      }
    }

    const encodedColor = encodeURIComponent(
      settingCompanyDetails?.default_color
    );
    const formData = new FormData();
    formData.append("main_image", overrideFile || fileData?.file);

    setIsLoadingColor(true);

    try {
      const response = await fetch(
        `https://images.tp.software/add-bg-color/?hex_color=${encodedColor}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Failed to add background color");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);

      setFiles((prev) =>
        prev.map((f) =>
          f.id === fileId ? { ...f, url: imageUrl, file: imageBlob } : f
        )
      );

      setSelectedImage({ url: imageUrl });
      toast.success("Background color added!");
      setIsModalOpen(false);
    } catch (error) {
      toast.error("Error adding background color");
    } finally {
      setIsLoadingColor(false);
    }
  };
  const handleRemoveBgImageeForm = async (fileId, alsoAddBg = false) => {
    const selectedImage = files.find((file) => file.id === fileId);
    if (!selectedImage) return;

    let fileData = selectedImage;

    if (selectedImage?.url) {
      try {
        const res = await axios({
          url: selectedImage?.url,
          method: "GET",
          responseType: "blob",
        });

        const myFile = new File([res.data], "image.png", {
          type: res.data.type,
        });

        fileData = {
          ...selectedImage,
          url: URL.createObjectURL(myFile),
          file: myFile,
        };
      } catch (err) {
        console.error("Error fetching the file:", err);
      }
    }

    const formData = new FormData();
    formData.append("file", fileData.file);

    setIsLoading(true);

    try {
      const response = await fetch(
        "https://images.tp.software/remove-bg/",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Failed to remove background");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);

      setFiles((prev) =>
        prev.map((f) =>
          f.id === fileId ? { ...f, url: imageUrl, file: imageBlob } : f
        )
      );

      setSelectedImage({ url: imageUrl });
      toast.success("Background removed!");

      if (alsoAddBg) {
        await handleAddBgColorForm(fileId, imageBlob);
      }

      setIsModalOpen(false);
    } catch (error) {
      toast.error("Error removing background");
    } finally {
      setIsLoading(false);
    }
  };

  async function urlToFile(url, filename, mimeType) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: mimeType || blob.type });
  }

  const handleAddBgImageForm = async (fileId) => {
    const selectedImage = files.find((file) => file.id === fileId);
    let fileData = selectedImage;

    if (selectedImage?.url) {
      try {
        const res = await axios({
          url: selectedImage.url,
          method: "GET",
          responseType: "blob",
        });

        const myFile = new File([res.data], "image.png", {
          type: res.data.type,
        });

        fileData = {
          ...selectedImage,
          url: URL.createObjectURL(myFile),
          file: myFile,
        };
      } catch (err) {
        console.error("Error fetching the file:", err);
        toast.error("Failed to load selected image.");
        return;
      }
    }

    const proxyUrl = "https://api.allorigins.win/raw?url=";

    const response = await fetch(
      proxyUrl + encodeURIComponent(settingCompanyDetails?.default_image)
    ); // Use proxy
    if (!response.ok) throw new Error("Default image is not available");

    const blob = await response.blob();
    const file = new File([blob], "background.jpg", { type: blob.type });

    if (!selectedImage) {
      toast.error("Please select an image first.");
      return;
    }

    setLoadingImageId(fileId);

    const formData = new FormData();
    formData.append("main_image", fileData.file);
    formData.append("bg_image", file);

    setIsLoadings(true);

    try {
      const response = await fetch("https://images.tp.software/add-bg/", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to remove background");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);
      setFiles((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file
        )
      );

      toast.success("Background add successfully!");
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
    } finally {
      setIsLoadings(false);
      setLoadingImageId(null);
    }
  };

  const handleRotate = async (fileId) => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const handleVehicleImageForm = (e) => {
    e.preventDefault();

    const newFiles = files.filter((file) => file.file);

    if (newFiles.length > 0) {
      const formData = new FormData();

      newFiles.forEach((file, index) => {
        let finalFile = file.file;

        if (file.url.startsWith("blob") || file.url.startsWith("data:image")) {
          fetch(file.url)
            .then((res) => res.blob())
            .then((blob) => {
              finalFile = new File([blob], `edited_image_${index}.jpg`, {
                type: "image/jpeg",
              });

              formData.append(`files[${index}]`, finalFile);
              formData.append(`sort_order[${index}]`, file.sequence);

              if (index === newFiles.length - 1) {
                submitVehicleImage(formData);
              }
            });
        } else {
          formData.append(`files[${index}]`, finalFile);
          formData.append(`sort_order[${index}]`, file.sequence);
        }
      });

      formData.append("vehicle_id", vehicleId);

      if (
        !newFiles.some(
          (file) =>
            file.url.startsWith("blob") || file.url.startsWith("data:image")
        )
      ) {
        submitVehicleImage(formData);
      }
    } else {
      setActiveTab("vehicle_video");
    }
  };

  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (hasProcessedRef.current) return;

    if (!files?.length || !settingCompanyDetails?.edit_photo_type) return;

    hasProcessedRef.current = true;

    const type = settingCompanyDetails.edit_photo_type;

    files.forEach((file) => {
      if (type === 2) {
        handleRemoveBgImageeForm(file.id);
      } else if (type === 3) {
        handleAddBgColorForm(file.id);
      } else if (type === 4) {
        handleAddBgImageForm(file.id);
      }
    });
  }, [files, settingCompanyDetails]);

  const submitVehicleImage = (formData) => {
    setbtnLoading(true);

    createVehicleImage(formData)
      .then((response) => {
        toast.success(response.data.message);

        setActiveTab("vehicle_video");
      })
      .catch((err) => toast.error(Utils.getErrorMessage(err)))
      .finally(() => {
        setbtnLoading(false);
      });
  };

  const saveDrawing = async (fileId) => {
    setIsDrawing((prev) => !prev);
    setTool(null);
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          {vehicleProcessList?.vehicle_image?.length > 0 ? (
            <>
              <div className="card card-primary">
                <Form method="post" onSubmit={handleVehicleImageForm}>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 ms-3">
                        <button
                          type="button"
                          onClick={() =>
                            document.getElementById("file-input").click()
                          }
                          className={`btn btn-sm btn-primary mb-2 ${
                            files.length === 0 ? "import-button-empty" : ""
                          }`}
                        >
                          <i className="bi bi-cloud-arrow-up me-2"></i> Upload
                          {t("images")}
                        </button>
                        <input
                          id="file-input"
                          className="form-control"
                          type="file"
                          onChange={handleFileChange}
                          name="file"
                          accept=".jpg,.png,.jpeg"
                          multiple
                          style={{ display: "none" }}
                        />
                        <div className="file-preview file-preview-custom">
                          <div className="file-list">
                            <PhotoProvider
                              visible={viewerOpen}
                              onVisibleChange={(v) => setViewerOpen(v)}
                              current={viewerIndex}
                              onIndexChange={(i) => setViewerIndex(i)}
                            >
                              {files?.length === 0 ? (
                                <p>{t("no_image_selected")}</p>
                              ) : (
                                files.map((file, index) => (
                                  <PhotoView key={index} src={file.url}>
                                    <div className="file-item file-item-custom">
                                      {/* EDIT BUTTON */}
                                      <i
                                        className="bi bi-pen-fill"
                                        style={{
                                          position: "absolute",
                                          top: "33px",
                                          cursor: "pointer",
                                          color: "blue",
                                          left: "13px",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleImageSelect(file);
                                        }}
                                      ></i>

                                      {/* GREEN EYE ICON — ONLY THIS OPENS VIEWER */}
                                      <i
                                        className="bi bi-eye-fill"
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          left: "13px",
                                          cursor: "pointer",
                                          color: "green",
                                          fontSize: "18px",
                                        }}
                                        onClick={() => {
                                          setViewerIndex(index); // set correct image index
                                          setViewerOpen(true); // open zoom viewer
                                        }}
                                      ></i>

                                      {/* IMAGE — CLICK DOES NOT OPEN VIEWER */}
                                      <img
                                        src={file.url}
                                        alt="preview"
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          objectFit: "cover",
                                          cursor: "default", // no zoom cursor
                                          pointerEvents: "none", // disable image click opening PhotoView
                                        }}
                                      />

                                      {/* DELETE BUTTON */}
                                      <i
                                        className="removeImageBtn bi bi-x"
                                        style={{
                                          position: "absolute",
                                          top: "33px",
                                          right: "13px",
                                          cursor: "pointer",
                                          color: "red",
                                        }}
                                        onClick={() => handleRemoveFile(file)}
                                      ></i>
                                    </div>
                                  </PhotoView>
                                ))
                              )}
                            </PhotoProvider>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12"></div>
                    </div>

                    <div className="buttonsB">
                      <div className="col">
                        <button
                          type="button"
                          className="back-btn"
                          onClick={() => setActiveTab("vehicle")}
                        >
                          <i className="bi bi-arrow-left"></i> {t("back")}
                        </button>
                      </div>
                      <div className="col">
                        <div className="btnNxtFns">
                          <button
                            type="button"
                            className="btn btn-primary nxt-btn"
                            onClick={handleImportModal}
                          >
                            {t("sort_order")} <i className="bi bi-arrow-right"></i>
                          </button>
                          {btnLoader === true ? (
                            <button type="submit" className="btn  btn-primary">
                              Loading...
                            </button>
                          ) : (
                            <button type="submit" className="btn  btn-primary">
                              {t("save")}

                              <i className="bi bi-arrow-right"></i>
                            </button>
                          )}

                          <button
                            type="button"
                            className="btn btn-primary nxt-btn"
                            onClick={() => setActiveTab("vehicle_extra_info")}
                          >
                            {t("next")}
                            <i className="bi bi-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>{" "}
              </div>{" "}
            </>
          ) : (
            <>
              <div className="card card-primary">
                <Form method="post" onSubmit={handleVehicleImageForm}>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          type="button"
                          onClick={() =>
                            document.getElementById("file-input").click()
                          }
                          className={`btn btn-sm btn-primary mb-2 ${
                            files.length === 0 ? "import-button-empty" : ""
                          }`}
                        >
                          <i className="bi bi-cloud-arrow-up me-2"></i>
                          {t("upload_multiple_images")}
                        </button>
                        <input
                          id="file-input"
                          className="form-control"
                          type="file"
                          onChange={handleFileChange}
                          name="file"
                          accept=".jpg,.png,.jpeg"
                          multiple
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>

                    <PhotoProvider>
                      <PhotoSlider
                        images={files.map((f) => ({ src: f.url }))}
                        visible={visible}
                        onClose={() => setVisible(false)}
                        index={activeIndex}
                        onIndexChange={setActiveIndex}
                      />

                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable
                          droppableId="fileList"
                          direction="horizontal"
                        >
                          {(provided) => (
                            <div
                              className="file-list"
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              style={{
                                display: "flex",
                                gap: "10px",
                                overflowX: "auto",
                              }}
                            >
                              {files.map((file, index) => (
                                <Draggable
                                  key={file.id || file.url}
                                  draggableId={file.id || file.url}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      className="file-item"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        ...provided.draggableProps.style,
                                        border: "1px solid #ddd",
                                        padding: "5px",
                                        borderRadius: "5px",
                                        position: "relative",
                                      }}
                                    >
                                      {/* Edit Button */}
                                      <i
                                        className="editImageBtn bi bi-pen-fill"
                                        style={{
                                          position: "absolute",
                                          top: "33px",
                                          cursor: "pointer",
                                          color: "blue",
                                          left: "13px",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleImageSelect(file);
                                        }}
                                      ></i>

                                      {/* View Button (Eye Icon) */}
                                      <i
                                        className="viewImageBtn bi bi-eye-fill"
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          left: "13px",
                                          cursor: "pointer",
                                          color: "green",
                                          fontSize: "18px",
                                        }}
                                        onClick={() => {
                                          setActiveIndex(index);
                                          setVisible(true);
                                        }}
                                      ></i>

                                      <PhotoView src={file.url}>
                                        <img
                                          src={file.url}
                                          alt="preview"
                                          style={{
                                            height: "100px",
                                            objectFit: "cover",
                                            width: "100px",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </PhotoView>

                                      <i
                                        className="removeImageBtn bi bi-x"
                                        style={{
                                          position: "absolute",
                                          top: "33px",
                                          right: "13px",
                                          cursor: "pointer",
                                          color: "red",
                                        }}
                                        onClick={(e) => {
                                          handleRemoveFile(file);
                                          e.stopPropagation();
                                        }}
                                      ></i>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </PhotoProvider>
                    <div className="back-footer">
                      <div className="row align-items-center">
                        <div className="col-4">
                          <button
                            type="button"
                            className="back-btn"
                            onClick={() => setActiveTab("vehicle")}
                          >
                            <i className="bi bi-arrow-left"></i> {t("back")}
                          </button>
                        </div>
                        <div className="col-4 text-center">
                          <small style={{ color: "#9ca3af" }}>
                            {t("step_x_of_n", { current: 2, total: 6 })}
                          </small>
                        </div>
                        <div className="col-4 text-end">
                          {btnLoader === true ? (
                            <button type="submit" className="btn  btn-primary">
                              {t("loading_dots")}
                            </button>
                          ) : (
                            <button type="submit" className="btn  btn-primary">
                              {t("save_and_continue")}
                              <i className="bi bi-arrow-right ms-1"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </div>
      </div>

      <Modal isOpen={modifyImportModal} toggle={handleImportCloseModal}>
        <Form method="post">
          <ModalHeader toggle={handleImportCloseModal}>
            {t("sort_order")}
          </ModalHeader>
          <ModalBody>
            <DragDropContext
              onDragEnd={(result) => {
                if (!result.destination) return;

                const reorderedFiles = Array.from(files);
                const [movedFile] = reorderedFiles.splice(
                  result.source.index,
                  1
                );
                reorderedFiles.splice(result.destination.index, 0, movedFile);

                const updatedFiles = reorderedFiles.map((file, index) => ({
                  ...file,
                  sequence: index + 1,
                }));

                setFiles(updatedFiles);
              }}
            >
              <Droppable droppableId="fileList" direction="vertical">
                {(provided) => (
                  <div
                    className="file-list"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {files.map((file, index) => (
                      <Draggable
                        key={file.id.toString()}
                        draggableId={file.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            className="file-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              border: "1px solid #ddd",
                              padding: "10px",
                              borderRadius: "5px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={file.url}
                              alt="Preview"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />{" "}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </ModalBody>

          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleImportCloseModal}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSaveOrder();
                handleImportCloseModal();
              }}
            >
              {t("save_order")}
            </button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={isModalOpen} toggle={closeModal} size="xl">
        <Form method="post">
          <ModalHeader toggle={closeModal}>{t("image_edit")}</ModalHeader>
          {selectedImage && (
            <ModalBody>
              <div className="modal-body" style={{ marginBottom: "150px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "400px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                      height: "394px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "800px",
                        height: "600px",
                      }}
                      onMouseDown={handleMouseCropDown}
                      onMouseMove={handleMouseCropeMove}
                      onMouseUp={handleMouseCropeUp}
                    >
                      <img
                        src={selectedImage?.url}
                        ref={imgRef}
                        onClick={onImageClick}
                        alt="Main"
                        style={{
                          width: "100%",
                          height: "50%",
                          objectFit: "cover",
                          transform: `rotate(${rotation}deg)`,
                          position: "absolute",
                          top: 0,
                          left: 0,
                          zIndex: 1,
                        }}
                      />

                      {isCropping && completedCrop && (
                        <div
                          style={{
                            position: "absolute",
                            border: "2px dashed #0b74de",
                            zIndex: 2,
                            left: `${completedCrop.x}px`,
                            top: `${completedCrop.y}px`,
                            width: `${completedCrop.width}px`,
                            height: `${completedCrop.height}px`,
                            pointerEvents: "none",
                          }}
                        />
                      )}

                      {toolImage && (
                        <Stage
                          width={800}
                          height={600}
                          ref={stageRef}
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            zIndex: 4,
                            backgroundColor: "transparent",
                          }}
                          onMouseDown={handleMouseDown}
                          onMouseMove={handleMouseMove}
                          onMouseUp={handleMouseUp}
                        >
                          <Layer>
                            {shapes.map((shape, index) =>
                              shape.type === "line" ? (
                                <Line
                                  key={shape.id}
                                  points={shape.points}
                                  stroke={color}
                                  strokeWidth={2}
                                  draggable
                                  onDragEnd={(e) =>
                                    handleDragMove(index, {
                                      points: shape.points.map((val, i) =>
                                        i % 2 === 0
                                          ? val + e.target.x()
                                          : val + e.target.y()
                                      ),
                                    })
                                  }
                                  onDblClick={() => handleDelete(shape.id)}
                                />
                              ) : (
                                <Circle
                                  key={shape.id}
                                  x={shape.x}
                                  y={shape.y}
                                  radius={shape.radius}
                                  stroke={color}
                                  strokeWidth={2}
                                  draggable
                                  onDragEnd={(e) =>
                                    handleDragMove(index, {
                                      x: e.target.x(),
                                      y: e.target.y(),
                                    })
                                  }
                                  onDblClick={() => handleDelete(shape.id)}
                                />
                              )
                            )}

                            {isDrawing && newShape?.type === "circle" && (
                              <Circle
                                x={newShape.x}
                                y={newShape.y}
                                radius={newShape.radius}
                                stroke={color}
                                dash={[4, 4]}
                              />
                            )}
                          </Layer>
                        </Stage>
                      )}
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: "40px" }}>
                    <div className="col-md-2">
                      <i
                        className="bi bi-crop"
                        style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          color: isCropping ? "blue" : "black",
                        }}
                        onClick={handleCrop}
                      ></i>
                    </div>

                    {/* <div className="col-md-2">
                      <i
                        className="bi bi-brush"
                        style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          color: isDrawing ? "blue" : "black",
                        }}
                        onClick={() => saveDrawing(selectedImage.id)}
                      ></i>
                    </div> */}

                    <div className="col-md-2">
                      <i
                        className="bi bi-arrow-counterclockwise"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() => handleRotate(selectedImage.id)}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-image"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() =>
                          handleRemoveBgImageeForm(selectedImage.id)
                        }
                        disabled={isLoading}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-image"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={(e) => handleAddBgImageForm(selectedImage.id)}
                        disabled={isLoadings}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-paint-bucket"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() => handleAddBgColorForm(selectedImage.id)}
                      ></i>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-2">
                      <span>Crop</span>
                    </div>

                    {/* <div className="col-md-2">
                      <span>{t("brush")}</span>
                    </div> */}

                    <div className="col-md-2">
                      <span>{t("rotate")}</span>
                    </div>

                    <div className="col-md-2">
                      <span>{isLoading ? "Processing..." : "Remove Back"}</span>
                    </div>

                    <div className="col-md-2">
                      <span> {isLoadings ? "Processing..." : "Add Back"}</span>
                    </div>

                    <div className="col-md-2">
                      <span>
                        {isLoadingColor ? "Processing..." : "Add Color"}
                      </span>
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: "40px" }}>
                    <div className="col-md-2">
                      <i
                        className="bi bi-crop"
                        style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          // color: isCropping ? "blue" : "black",
                        }}
                        onClick={() => {
                          setTool("line");
                          setToolImage(true);
                        }}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-brush"
                        style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          color: isDrawing ? "blue" : "black",
                        }}
                        onClick={() => {
                          setTool("circle");

                          setToolImage(true);
                        }}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-arrow-counterclockwise"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() => handleRotate(selectedImage.id)}
                      ></i>
                    </div>

                    <div className="col-md-2"></div>

                    <div className="col-md-2"></div>

                    <div className="col-md-2"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-2">
                      <span>line</span>
                    </div>

                    <div className="col-md-2">
                      <span>circle</span>
                    </div>

                    <div className="col-md-2">
                      <span>Undo</span>
                    </div>

                    <div className="col-md-2"></div>

                    <div className="col-md-2"></div>

                    <div className="col-md-2"></div>
                  </div>
                </div>
              </div>
            </ModalBody>
          )}
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={getCroppedImage}
            >
              Apply Changes
            </button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default VehicleImage;
